import { createAsyncThunk } from "@reduxjs/toolkit";
import { Users } from "../../../client/services";
import { toastHandler } from "../../../utils/toastHandler";
import { FindUserList } from "../../users/api/interfaces";

export const findSelectUsers = createAsyncThunk(
  "selectUsers/findSelectUsers",
  async (values: FindUserList, { rejectWithValue }) => {
    try {
      const response = await Users.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const searchSelectUsers = createAsyncThunk(
  "selectUsers/searchSelectUsers",
  async (values: FindUserList, { rejectWithValue }) => {
    try {
      const response = await Users.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

